<template>
  <naj-modal-2
    ref="dynamicFormModal"
    :title="title"
    :close-button="true"
    :width="1600"
    show-footer-close-button
    @onClose="closeModal"
  >
    <v-form
      v-if="modalVisibility"
      ref="modalDynamicFormRef"
      @submit.prevent="submit"
    >
      <naj-loader v-if="loading"></naj-loader>
      <naj-dynamic-form
        v-else
        :form-model="formModel"
        :root-form-model="rootFormModel"
        :required-data="requiredData"
        :data-sources="dataSources"
        :form-fields="fields"
        :hide-naj-box="true"
        :view-mode="viewMode"
        :custom-component-name="customComponentName"
      ></naj-dynamic-form>
    </v-form>
    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <!-- :disabled="" -->
      <naj-button
        v-if="!viewMode && !hideSubmitButton"
        @click="submit(closeNajModal)"
      >
        {{
          submitButtonText || local.common.add
        }}
      </naj-button>
    </template>
  </naj-modal-2>
</template>

<script>
import { formReset } from '@/helpers/form';
export default {
  name: 'DynamicFormModal',
  components: {},
  props: [
    'modalVisibility',
    'title',
    'fields',
    'submitButtonText',
    'hideSubmitButton',
    'viewMode',
    'customComponentName',
    'initialFormModel',
    'formModel',
    'rootFormModel',
    'validateOnSubmit',
    'dataSources',
    'requiredData',
  ],
  computed: {
    loading() {
      return (!this.fields || !this.fields.length) && !this.customComponentName;
    },
  },
  watch: {
    modalVisibility(newValue) {
      if (newValue) {
        formReset(this, 'modalDynamicFormRef');
        this.$refs.dynamicFormModal.show();
      } else {
        this.$refs.dynamicFormModal.close();
      }
    },
  },
  methods: {
    showModal() {
      this.$refs.dynamicFormModal.show();
    },
    closeModal() {
      this.$emit('onClose');
    },
    submit() {
      if (this.validateOnSubmit) {
        this.$refs.modalDynamicFormRef.$validator.validateAll()
          .then((isValid) => {
            if (isValid) {
              // valid
              this.$emit('formSubmitted', this.formModel);
              this.closeModal();
            } else {
              // not valid
            }
          });
      } else {
        this.$emit('formSubmitted', this.formModel);
        this.closeModal();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
